export default __webpack_public_path__ + "static/backgroundIBlocks-1af6590818560c2f6f8238053383465e.svg";